import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 19V17H12V19H2ZM2 14V12H7V14H2ZM2 9V7H7V9H2ZM20.6 19L16.75 15.15C16.35 15.4333 15.9127 15.6457 15.438 15.787C14.9627 15.929 14.4833 16 14 16C12.6167 16 11.4377 15.5123 10.463 14.537C9.48767 13.5623 9 12.3833 9 11C9 9.61667 9.48767 8.43733 10.463 7.462C11.4377 6.48733 12.6167 6 14 6C15.3833 6 16.5627 6.48733 17.538 7.462C18.5127 8.43733 19 9.61667 19 11C19 11.4833 18.9293 11.9627 18.788 12.438C18.646 12.9127 18.4333 13.35 18.15 13.75L22 17.6L20.6 19ZM14 14C14.8333 14 15.5417 13.7083 16.125 13.125C16.7083 12.5417 17 11.8333 17 11C17 10.1667 16.7083 9.45833 16.125 8.875C15.5417 8.29167 14.8333 8 14 8C13.1667 8 12.4583 8.29167 11.875 8.875C11.2917 9.45833 11 10.1667 11 11C11 11.8333 11.2917 12.5417 11.875 13.125C12.4583 13.7083 13.1667 14 14 14Z",
      fill: "#3261DB"
    }, null, -1)
  ]))]))
}
export default { render: render }